var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-loading",attrs:{"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.name)+" "),(_vm.loading)?_c('div',{staticClass:"loading-spinner"},[_c('div',{staticClass:"spin-icon"})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }